module.exports = "<ui-select multiple ng-model=\"$ctrl.value\" uis-open-close=\"$ctrl.updateViewValue(isOpen)\" required on-remove=\"$ctrl.setValue($item, $model)\">\n    <ui-select-match placeholder=\"Role\">\n        {{ $item.name }}\n    </ui-select-match>\n\n    <ui-select-choices repeat=\"item in $ctrl.roles | filter: { name: $select.search } track by item.value\">\n        <div ng-bind-html=\"item.name | highlight: $select.search\"></div>\n        <small>{{ item.description }}</small>\n    </ui-select-choices>\n</ui-select>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/user/views/role.select.html
// module id = 481
// module chunks = 0